export default class StickyAtcBar extends HTMLElement {
  constructor() {
    super();
    this.trigger = document.querySelector("#variant-selector");
    this.stickyAtcBar = document.querySelector("#sticky-atc-bar");
    this.footer = document.querySelector(".footer");
  }

  connectedCallback() {
    this.stickyAtcBar.classList.add("translate-y-0!", "opacity-100");
    this._onScroll = this.handleScroll.bind(this);
    if (window.innerWidth > 1000) {
      window.addEventListener("scroll", this._onScroll);
    } else {
      window.addEventListener("scroll", this._onScroll, { passive: true });
    }
  }

  handleScroll() {
    const triggerBottom = this.trigger?.getBoundingClientRect().top;
    const footerRect = this.footer?.getBoundingClientRect();
    const footerMid = footerRect ? footerRect.top + footerRect.height / 2 : Infinity;
    const barHeight = this.stickyAtcBar.offsetHeight;
    const reachedFooter = footerMid <= window.innerHeight - barHeight;

    if (reachedFooter || (triggerBottom > 0 && window.scrollY !== 0)) {
      this.stickyAtcBar.classList.remove("translate-y-0!", "opacity-100");
    } else {
      this.stickyAtcBar.classList.add("translate-y-0!", "opacity-100");
    }
  }
}

customElements.define("sticky-atc-bar", StickyAtcBar);
